<div @dialogAnimation class="p-4 w-[400px] ">
    <div class="flex justify-end">
        <mat-icon class="flex justify-end cursor-pointer hover:text-[#4f3422]"
            (click)="closePopup('close')">close</mat-icon>
    </div>
    <div class="flex flex-col justify-center pt-6 pb-10">
        <div class="flex justify-center text-[20px]mt-5">
            {{warningMsg}}
        </div>
        <div class="flex justify-center w-[100%] mt-8 gap-5">
            <button class="bg-[#A4A5A8] text-white border-2 h-[37px] px-7 border-[#A4A5A8] rounded outline-none"
                (click)="closePopup(firstButton)">{{firstButton}}</button>
            <button class="bg-[#5F46D4] text-white border-2 h-[37px] px-7 border-[#5F46D4] rounded outline-none"
                (click)="closePopup(secondButton)">{{secondButton}}</button>
        </div>
    </div>
</div>